import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

// ______뒤로 가기 버튼______
export default function GoBackButton({
  category = "",
  index = "",
  value = "",
  treeBuildingName = "",
  treeFloor = "",
  treeLocation = "",
  treeFacilityType = "",
  treeFacilityName = "",
  t,
}) {
  const navigate = useNavigate();
  const { t: i18nT, i18n } = useTranslation();
  const label = String(i18n.resolvedLanguage || i18n.language || "ko").startsWith("ko") ? "목록으로 돌아가기" : typeof t === "function"
    ? t("projectDetail.goBackButton")
    : i18nT("projectDetail.goBackButton");

  const handlePageChange = () => {
    if (
      !category &&
      !index &&
      !value &&
      !treeBuildingName &&
      !treeFloor &&
      !treeLocation &&
      !treeFacilityType &&
      !treeFacilityName
    ) {
      navigate("/project");
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={handlePageChange}
      className="goBackBtn"
      aria-label={label}
      title={label}
    >
      <ArrowLeft size={17} strokeWidth={2} aria-hidden="true" />
      <span>{label}</span>
    </button>
  );
}
